import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../../core/Button/index.js';
/**
 * 获取对齐方式的类名
 */
const getAlignClass = (align) => {
    switch (align) {
        case 'left':
            return 'justify-start';
        case 'center':
            return 'justify-center';
        case 'right':
            return 'justify-end';
        default:
            return 'justify-end';
    }
};
/**
 * 获取间距的类名
 */
const getSpacingClass = (spacing, direction) => {
    if (direction === 'horizontal') {
        switch (spacing) {
            case 'sm':
                return 'space-x-2';
            case 'md':
                return 'space-x-4';
            case 'lg':
                return 'space-x-6';
            default:
                return 'space-x-4';
        }
    }
    else {
        switch (spacing) {
            case 'sm':
                return 'space-y-2';
            case 'md':
                return 'space-y-4';
            case 'lg':
                return 'space-y-6';
            default:
                return 'space-y-4';
        }
    }
};
/**
 * 按钮组组件
 * 便于管理常见的按钮组合场景
 */
export const ButtonGroup = ({ submitProps = {}, cancelProps = {}, submitText = 'Submit', cancelText = 'Cancel', submitOnly = false, direction = 'horizontal', onSubmit, onCancel, align = 'right', spacing = 'md', className = '', loading = false, }) => {
    // 构建容器类名
    const containerClasses = [
        direction === 'horizontal' ? 'flex' : 'flex flex-col',
        getAlignClass(align),
        getSpacingClass(spacing, direction),
        className,
    ]
        .filter(Boolean)
        .join(' ');
    // 默认提交按钮属性
    const defaultSubmitProps = {
        variant: 'primary',
        type: 'submit',
        loading,
        ...submitProps,
        children: submitProps.text || submitText,
        onClick: e => {
            // 如果提供了onSubmit处理函数，阻止默认表单提交行为并调用它
            if (onSubmit) {
                e.preventDefault();
                onSubmit();
            }
            // 调用传入的onClick处理函数(如果存在)
            submitProps.onClick?.(e);
        },
    };
    // 默认取消按钮属性
    const defaultCancelProps = {
        variant: 'outline',
        type: 'button',
        disabled: loading, // 加载中时禁用取消按钮
        ...cancelProps,
        children: cancelProps.text || cancelText,
        onClick: e => {
            if (onCancel) {
                onCancel();
            }
            cancelProps.onClick?.(e);
        },
    };
    return (_jsxs("div", { className: containerClasses, role: "group", "aria-label": "Action button group", children: [direction === 'horizontal' && align !== 'right' && !submitOnly && (_jsx(Button, { ...defaultCancelProps })), _jsx(Button, { ...defaultSubmitProps }), (direction === 'vertical' || align === 'right') && !submitOnly && (_jsx(Button, { ...defaultCancelProps }))] }));
};
// 默认导出，保持兼容性
export default ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map